import { cx } from '@flowus/common/cx';
import { useState, type FC } from 'react';
import { isMobile } from 'react-device-detect';
import { Icon } from 'src/common/components/icon';

interface Props {
  name: string;
  onAddWiki?: () => void;
}
export const WikiTocItemGroup: FC<Props> = (props) => {
  const [expand, setExpand] = useState(true);
  return (
    <>
      <div className="px-2 mx-2 space-x-1 space-y-1 animate-hover">
        <div
          className={cx('flex items-center justify-between h-8', {
            'h-10': isMobile,
          })}
          onClick={() => setExpand(!expand)}
        >
          <div className="flex items-center space-x-3">
            <Icon
              name={'IcArrowRight01'}
              size="xxsmall"
              style={{
                rotate: expand ? '90deg' : '0deg',
              }}
            />
            <span className="text-t2-medium text-grey3 ml-1">{props.name}</span>
          </div>
          {props.onAddWiki && (
            <div className="px-1 animate-hover">
              <Icon
                className="text-grey3 "
                name={'IcAdd'}
                size="xsmall"
                onClick={(e) => {
                  e.stopPropagation();
                  props.onAddWiki?.();
                }}
              />
            </div>
          )}
        </div>
      </div>
      <div className={cx('', expand ? '' : 'hidden')}>{props.children}</div>
    </>
  );
};
